const formDataInputs = (data: any): FormData => {
  const form = new FormData();

  for (const key in data) {
    if (data[key]) form.append(key, data[key]);
  }

  return form;
};

export { formDataInputs };



// WEBPACK FOOTER //
// ./src/tools/formdatainputs.ts